import React from "react";
import { Link } from "react-router-dom";
import "../../styles/FailedTransaction.scss";
import { AiFillExclamationCircle as AiIcon } from "react-icons/ai";

const AiFillExclamationCircle = AiIcon as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

const FailedTransaction = () => {
  return (
    <div className="failed-container">
      <div className="failed-content">
        <AiFillExclamationCircle className="failed-icon" />
        <h2 className="failed-title">Payment Transaction Failed</h2>
        <p className="failed-text">Please try again.</p>
        <Link to="/" className="failed-button">
          Back to Event Page
        </Link>
      </div>
    </div>
  );
};

export default FailedTransaction;
